export default __webpack_public_path__ + "images/logoPatchology.f530df8dde2c5f32ca0f7350ffb9aaaa.svg"